import { render, staticRenderFns } from "./FormOfferType.vue?vue&type=template&id=2dcd37e8&scoped=true&"
import script from "./FormOfferType.vue?vue&type=script&lang=js&"
export * from "./FormOfferType.vue?vue&type=script&lang=js&"
import style0 from "./FormOfferType.vue?vue&type=style&index=0&id=2dcd37e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcd37e8",
  null
  
)

export default component.exports